import IInterventionStatusDateChanged from 'models/InterventionStatusChangedDate';

import { ReduxStore } from 'store/types';

function getStatusDateChangedValues(
  state: ReduxStore,
): IInterventionStatusDateChanged[] {
  return state.intervention.getStatusDateChanged.values;
}

export default getStatusDateChangedValues;
